import React from 'react';
import styled from 'styled-components';
import TriangleLegend from './Shapes/TriangleLegend';
import CircleLegend from './Shapes/CircleLegend';
import DiamondLegend from './Shapes/DiamondLegend';
import RectangleLegend from './Shapes/RectangleLegend';

const LegendContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 20px;

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    margin-top: 30px;
  }

  .itemContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 20px;
    justify-content: center;
    :not(:last-child) {
      margin-right: 3%;
    }
    p {
      font-family: ${(props) => props.theme.fonts.sfcompact_text};
      font-size: 12px;
      margin-left: 20px;
    }
    font-size: 12px;
    text-transform: capitalize;
  }

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    flex-direction: column;
    align-items: flex-start;
    margin-left: 40%;

    .itemContainer {
      margin-right: 0px;
    }
  }

  @media (max-width: 1500px) and (min-width: 845px) {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    margin-left: 20%;
    grid-gap: 10px;

    .itemContainer {
      margin-right: 0px;
      justify-content: flex-start;
    }
  }

  ${(props) => props.styles}
`;

const Legend = ({ labels, colors, onlyCircle }) => {
  const shapes = [CircleLegend, TriangleLegend, DiamondLegend, RectangleLegend];

  return (
    <LegendContainer>
      {labels.map((entry, index) => {
        const Component = shapes[onlyCircle ? 0 : parseInt(index % 4, 10)];
        return (
          <div className="itemContainer" key={`legend-${index}`}>
            <Component color={colors[index]} />
            <p key={`item-${index}`}>{labels[index]}</p>
          </div>
        );
      })}
    </LegendContainer>
  );
};

export default Legend;
